export default {
    addTeamMember: 'Add Team Member',
    administrator: 'Administrator',
    approveDocuments: 'Approve documents',
    createEditDeleteAnApprovalFlow: 'Create/Edit/Delete an Approval Flow',
    documentApproval: 'Document Approval',
    documents: 'Documents',
    group: 'Group',
    groupHelpText:
        'Documents and clients owned by a group are only visible to members of the group',
    headerText0:
        'You are about to invite this person to join {{companyName}} on MakeLeaps. Please enter their email address and an email invitation will be sent to this address with a link which can be used to sign up and join your company.',
    headerText1: 'This person will be able to view the data in your company.',
    other: 'Other',
    requestApprovalForDocuments: 'Request approval for documents',
    salesManagement: 'Sales Management',
    salesManagementHelpText:
        'MakeLeaps “Sales management” feature means the ability to create/convert documents, send by email or post, and mark as sent or paid anytime.',
    save: 'Save Employee Rights',
    timeTracking: 'Time Tracking',
    timeTrackingHelpText:
        'Enabling Time Tracking automatically grants the Timesheet Create/Edit/Delete rights, as well as the Timesheet Cancel right.',
    upgrade:
        'You can get more full access licenses by <0>Upgrading</0> to a bigger plan.',
    userLicense: 'User License',
    whatIsTimeTracking: 'What is Time Tracking?',
};
